import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "file-list-wrap"
};
const _hoisted_2 = {
  class: "table-container"
};
const _hoisted_3 = {
  class: "table-row"
};
const _hoisted_4 = {
  class: "footer-div"
};
const _hoisted_5 = {
  class: "footer-item1"
};
const _hoisted_6 = {
  class: "footer-item2"
};
const _hoisted_7 = {
  class: "footer-item1"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_score_table1_header = _resolveComponent("score-table1-header");
  const _component_score_table1_body1 = _resolveComponent("score-table1-body1");
  const _component_score_table1_body2 = _resolveComponent("score-table1-body2");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_scrollbar = _resolveComponent("el-scrollbar");
  const _component_el_button = _resolveComponent("el-button");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_scrollbar, {
    class: "body-scroll"
  }, {
    default: _withCtx(() => [_cache[28] || (_cache[28] = _createElementVNode("div", {
      class: "table-title"
    }, "服务考核评估表", -1)), _cache[29] || (_cache[29] = _createElementVNode("div", {
      class: "table-row-bold"
    }, "考核项目", -1)), _createVNode(_component_score_table1_header, {
      item: "一、整体表现部分"
    }), _createVNode(_component_score_table1_body1, {
      item: "1.1 以饱满的热情、积极的心态投入服务",
      score: _ctx.score1.score11,
      "onUpdate:score": _cache[0] || (_cache[0] = $event => _ctx.score1.score11 = $event),
      "is-sum": _ctx.confirm > -1
    }, null, 8, ["score", "is-sum"]), _createVNode(_component_score_table1_body1, {
      item: "1.2 了解企业文化、品牌及业务",
      score: _ctx.score1.score12,
      "onUpdate:score": _cache[1] || (_cache[1] = $event => _ctx.score1.score12 = $event),
      "is-sum": _ctx.confirm > -1
    }, null, 8, ["score", "is-sum"]), _createVNode(_component_score_table1_body1, {
      item: "1.3 了解消费者的需求、态度、价值和媒介行为",
      score: _ctx.score1.score13,
      "onUpdate:score": _cache[2] || (_cache[2] = $event => _ctx.score1.score13 = $event),
      "is-sum": _ctx.confirm > -1
    }, null, 8, ["score", "is-sum"]), _createVNode(_component_score_table1_body1, {
      item: "1.4 能在第一时间响应服务要求",
      score: _ctx.score1.score14,
      "onUpdate:score": _cache[3] || (_cache[3] = $event => _ctx.score1.score14 = $event),
      "is-sum": _ctx.confirm > -1
    }, null, 8, ["score", "is-sum"]), _createVNode(_component_score_table1_body1, {
      item: "1.5 能根据需求有效组织与安排工作",
      score: _ctx.score1.score15,
      "onUpdate:score": _cache[4] || (_cache[4] = $event => _ctx.score1.score15 = $event),
      "is-sum": _ctx.confirm > -1
    }, null, 8, ["score", "is-sum"]), _createVNode(_component_score_table1_body1, {
      item: "1.6 各环节质量控制严格，工作效率和效果佳",
      score: _ctx.score1.score16,
      "onUpdate:score": _cache[5] || (_cache[5] = $event => _ctx.score1.score16 = $event),
      "is-sum": _ctx.confirm > -1
    }, null, 8, ["score", "is-sum"]), _createVNode(_component_score_table1_body1, {
      item: "1.7 根据客户服务要求弹性安排工作时间",
      score: _ctx.score1.score17,
      "onUpdate:score": _cache[6] || (_cache[6] = $event => _ctx.score1.score17 = $event),
      "is-sum": _ctx.confirm > -1
    }, null, 8, ["score", "is-sum"]), _createVNode(_component_score_table1_body1, {
      item: "1.8 能虚心接受客户建议并及时给予反馈",
      score: _ctx.score1.score18,
      "onUpdate:score": _cache[7] || (_cache[7] = $event => _ctx.score1.score18 = $event),
      "is-sum": _ctx.confirm > -1
    }, null, 8, ["score", "is-sum"]), _createVNode(_component_score_table1_body1, {
      item: "1.9 形成了很好的工作默契",
      score: _ctx.score1.score19,
      "onUpdate:score": _cache[8] || (_cache[8] = $event => _ctx.score1.score19 = $event),
      "is-sum": _ctx.confirm > -1
    }, null, 8, ["score", "is-sum"]), _createVNode(_component_score_table1_body1, {
      item: "1.10 人事或组织方面的变动没有影响正常的项目开展",
      score: _ctx.score1.score110,
      "onUpdate:score": _cache[9] || (_cache[9] = $event => _ctx.score1.score110 = $event),
      "is-sum": _ctx.confirm > -1
    }, null, 8, ["score", "is-sum"]), _createVNode(_component_score_table1_body1, {
      item: "1.11 在工作项目之外呈现对企业的兴趣并提供建议与帮助",
      score: _ctx.score1.score111,
      "onUpdate:score": _cache[10] || (_cache[10] = $event => _ctx.score1.score111 = $event),
      "is-sum": _ctx.confirm > -1
    }, null, 8, ["score", "is-sum"]), _createVNode(_component_score_table1_body1, {
      item: "小计",
      score1: -11,
      score2: 0,
      score3: 22,
      score4: 32,
      score5: 43,
      score6: 52,
      "is-sum": true,
      score: $setup.scoreSum1,
      "onUpdate:score": _cache[11] || (_cache[11] = $event => $setup.scoreSum1 = $event)
    }, null, 8, ["score"]), _createVNode(_component_score_table1_header, {
      item: "二、具体工作部分"
    }), _createVNode(_component_score_table1_body2, {
      item: "2.1 客户品牌，增值业务以及集团业务的整合营销传播规划及时性",
      score: _ctx.score2.score21,
      "onUpdate:score": _cache[12] || (_cache[12] = $event => _ctx.score2.score21 = $event),
      "is-sum": _ctx.confirm > -1
    }, null, 8, ["score", "is-sum"]), _createVNode(_component_score_table1_body2, {
      item: "2.2 提交的策划方案符合项目需求,准确有效的解决项目问题",
      score: _ctx.score2.score22,
      "onUpdate:score": _cache[13] || (_cache[13] = $event => _ctx.score2.score22 = $event),
      "is-sum": _ctx.confirm > -1
    }, null, 8, ["score", "is-sum"]), _createVNode(_component_score_table1_body2, {
      item: "2.3 策划方案是否逻辑严密、科学、合理，具有较好的可执行性",
      score: _ctx.score2.score23,
      "onUpdate:score": _cache[14] || (_cache[14] = $event => _ctx.score2.score23 = $event),
      "is-sum": _ctx.confirm > -1
    }, null, 8, ["score", "is-sum"]), _createVNode(_component_score_table1_body2, {
      item: "2.4 能够按时提交工作成果（创意和传播策略）",
      score: _ctx.score2.score24,
      "onUpdate:score": _cache[15] || (_cache[15] = $event => _ctx.score2.score24 = $event),
      "is-sum": _ctx.confirm > -1
    }, null, 8, ["score", "is-sum"]), _createVNode(_component_score_table1_body2, {
      item: "2.5 月度工作总结的时效性、指导性",
      score: _ctx.score2.score25,
      "onUpdate:score": _cache[16] || (_cache[16] = $event => _ctx.score2.score25 = $event),
      "is-sum": _ctx.confirm > -1
    }, null, 8, ["score", "is-sum"]), _createVNode(_component_score_table1_body2, {
      item: "2.6 广告创意吻合策略",
      score: _ctx.score2.score26,
      "onUpdate:score": _cache[17] || (_cache[17] = $event => _ctx.score2.score26 = $event),
      "is-sum": _ctx.confirm > -1
    }, null, 8, ["score", "is-sum"]), _createVNode(_component_score_table1_body2, {
      item: "2.7 广告创意概念新颖",
      score: _ctx.score2.score27,
      "onUpdate:score": _cache[18] || (_cache[18] = $event => _ctx.score2.score27 = $event),
      "is-sum": _ctx.confirm > -1
    }, null, 8, ["score", "is-sum"]), _createVNode(_component_score_table1_body2, {
      item: "2.8 广告创意的延续性",
      score: _ctx.score2.score28,
      "onUpdate:score": _cache[19] || (_cache[19] = $event => _ctx.score2.score28 = $event),
      "is-sum": _ctx.confirm > -1
    }, null, 8, ["score", "is-sum"]), _createVNode(_component_score_table1_body2, {
      item: "2.9 广告活动对销售的帮助",
      score: _ctx.score2.score29,
      "onUpdate:score": _cache[20] || (_cache[20] = $event => _ctx.score2.score29 = $event),
      "is-sum": _ctx.confirm > -1
    }, null, 8, ["score", "is-sum"]), _createVNode(_component_score_table1_body2, {
      item: "2.10 广告活动对企业品牌及各服务品牌形象价值的提升",
      score: _ctx.score2.score210,
      "onUpdate:score": _cache[21] || (_cache[21] = $event => _ctx.score2.score210 = $event),
      "is-sum": _ctx.confirm > -1
    }, null, 8, ["score", "is-sum"]), _createVNode(_component_score_table1_body1, {
      item: "小计",
      score1: -20,
      score2: -10,
      score3: 18,
      score4: 28,
      score5: 38,
      score6: 48,
      "is-sum": true,
      score: $setup.scoreSum2,
      "onUpdate:score": _cache[22] || (_cache[22] = $event => $setup.scoreSum2 = $event)
    }, null, 8, ["score"]), _createVNode(_component_score_table1_body1, {
      item: "合计",
      score1: -31,
      score2: -10,
      score3: 40,
      score4: 60,
      score5: 81,
      score6: 100,
      "is-sum": true,
      score: $setup.scoreSum,
      "onUpdate:score": _cache[23] || (_cache[23] = $event => $setup.scoreSum = $event)
    }, null, 8, ["score"]), _cache[30] || (_cache[30] = _createElementVNode("div", {
      class: "table-row"
    }, "注：表格的评分直接影响服务质量及体现乙方承诺的兑现情况。", -1)), _createElementVNode("div", _hoisted_3, [_createTextVNode(" 评分结果：得分     " + _toDisplayString($setup.scoreSum) + "     ；发放考核月费比例     ", 1), _ctx.confirm > -1 ? (_openBlock(), _createBlock(_component_el_input, {
      key: 0,
      class: "rate-input",
      "model-value": _ctx.fillRate,
      size: "medium",
      readonly: ""
    }, null, 8, ["model-value"])) : (_openBlock(), _createBlock(_component_el_input, {
      key: 1,
      class: "rate-input",
      modelValue: _ctx.fillRate,
      "onUpdate:modelValue": _cache[24] || (_cache[24] = $event => _ctx.fillRate = $event),
      size: "medium"
    }, null, 8, ["modelValue"])), _cache[27] || (_cache[27] = _createTextVNode(" 。 ", -1))])]),
    _: 1
  }), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_cache[31] || (_cache[31] = _createTextVNode(" 考核人签字： ", -1)), _ctx.confirm > -1 ? (_openBlock(), _createBlock(_component_el_input, {
    key: 0,
    class: "rate-input",
    "model-value": _ctx.examiner,
    size: "medium",
    readonly: ""
  }, null, 8, ["model-value"])) : (_openBlock(), _createBlock(_component_el_input, {
    key: 1,
    class: "rate-input",
    modelValue: _ctx.examiner,
    "onUpdate:modelValue": _cache[25] || (_cache[25] = $event => _ctx.examiner = $event),
    size: "medium"
  }, null, 8, ["modelValue"]))]), _createElementVNode("div", _hoisted_6, [_cache[32] || (_cache[32] = _createTextVNode(" 被考核单位确认签字： ", -1)), _ctx.confirm > 0 ? (_openBlock(), _createBlock(_component_el_input, {
    key: 0,
    class: "rate-input1",
    "model-value": _ctx.examinee,
    size: "medium",
    readonly: ""
  }, null, 8, ["model-value"])) : (_openBlock(), _createBlock(_component_el_input, {
    key: 1,
    class: "rate-input1",
    modelValue: _ctx.examinee,
    "onUpdate:modelValue": _cache[26] || (_cache[26] = $event => _ctx.examinee = $event),
    size: "medium"
  }, null, 8, ["modelValue"]))]), _createElementVNode("div", _hoisted_7, " 日期：" + _toDisplayString(_ctx.examTime), 1)]), _ctx.confirm < 1 ? (_openBlock(), _createBlock(_component_el_button, {
    key: 0,
    class: "submit-btn",
    size: "mini",
    type: "primary",
    onClick: $setup.submit
  }, {
    default: _withCtx(() => [...(_cache[33] || (_cache[33] = [_createTextVNode(" 提交 ", -1)]))]),
    _: 1
  }, 8, ["onClick"])) : _createCommentVNode("", true)])]);
}